import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Farm } from 'src/app/models/farm/farm.model';

export const FarmSelector = createFeatureSelector<Farm>('farm');

export const getFarm = createSelector(FarmSelector, (state: Farm) => state);
